var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-763.000000, -1423.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/remove",
    transform: "translate(763.000000, 1423.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4246212,12.3033009 L18.3137085,16.1923882 C18.7042328,16.5829124 18.7042328,17.2160774 18.3137085,17.6066017 L17.6066017,18.3137085 C17.2160774,18.7042328 16.5829124,18.7042328 16.1923882,18.3137085 L12.3033009,14.4246212 L8.41421356,18.3137085 C8.02368927,18.7042328 7.39052429,18.7042328 7,18.3137085 L6.29289322,17.6066017 C5.90236893,17.2160774 5.90236893,16.5829124 6.29289322,16.1923882 L10.1819805,12.3033009 L6.29289322,8.41421356 C5.90236893,8.02368927 5.90236893,7.39052429 6.29289322,7 L7,6.29289322 C7.39052429,5.90236893 8.02368927,5.90236893 8.41421356,6.29289322 L12.3033009,10.1819805 L16.1923882,6.29289322 C16.5829124,5.90236893 17.2160774,5.90236893 17.6066017,6.29289322 L18.3137085,7 C18.7042328,7.39052429 18.7042328,8.02368927 18.3137085,8.41421356 L14.4246212,12.3033009 Z",
    id: "Combined-Shape",
    fill: "#858199",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/iconRemove.f81d74c1.svg";
export { ForwardRef as ReactComponent };